import styled from 'styled-components'
import { Box } from '@usap/uicomponents'

const ArticleMenu = styled(Box)`
  width: 100%;
  margin-bottom: 20px;

  @media (min-width: ${props => props.theme.global.breakpoints.laptop.value}px) {
    width: 25%;
    margin-bottom: inherit;
  }
`

export default ArticleMenu
